<div class="app-body min-vh-100">
  <main class="main d-flex align-items-center">

    <div class="container">
      <div class="card card-phone">
        <div class="row">
          <div class="col-md-6 text-center">
            <img class="mt-3" src="assets/img/login/SIAP BOS_login_ilustrasi.png" alt="SIAP Logo" width="100%"
              height="100%">
          </div>
          <div class="col-md-6">
            <h6 class="mt-5 h4 text-center poppins-bold">
              SIAP BOSP BOP
            </h6>
            <p class="mt-3 text-center fs-5">SELAMAT DATANG SILAHKAN LOGIN</p>

            <form action="mt-5" [formGroup]="formGroup" (submit)="login()" *ngIf="!newUser"
              class="row align-items-center justify-content-center">
              <div class="col-10 col-md-11 col-lg-8">
                <div class="form-group text-center">
                  <select class="form-control rounded-pill w-100 manrope-regular" formControlName="tahunAnggaran">
                    <option value="" disabled>Tahun Anggaran</option>
                    <!-- data untuk dummy -->
                    <!-- <option value="2021" >2021</option>
                      <option value="2022" >2022</option> -->
                    <option *ngFor="let tahun of listTahunAnngaran" [value]="tahun">{{tahun}}</option>
                  </select>
                </div>

                <div class="form-group mt-4 text-center">
                  <input type="text" class="form-control rounded-pill w-100 manrope-regular" placeholder="ID Login"
                    autocomplete="username" formControlName="username">
                  <div *ngIf="submitted && formGroup.controls.username.errors" class="invalid-feedback pd-valid-form">
                    <div *ngIf="formGroup.controls.username.errors?.required" class="text text-danger pd-valid-form">
                      ID Login harus diisi
                    </div>
                  </div>
                </div>

                <div class="form-group mt-4 text-center">
                  <input type="password" class="form-control rounded-pill w-100 manrope-regular" placeholder="Password"
                    autocomplete="current-password" formControlName="password">
                </div>

                <div class="form-row mt-4">
                  <div class="col mt-1">
                    <div class="form-group text-center">
                      <input type="text" class="form-control form-control-lg rounded-pill w-100 manrope-regular"
                        placeholder="Ketik Captcha" formControlName="captcha" [ngClass]="{
                          'is-invalid': submitted && formGroup.controls.captcha.errors || checkCaptcha(),
                          'is-valid': !formGroup.controls.captcha.valid || !checkCaptcha()}">
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group text-center">
                      <span
                        class="form-control form-control-lg rounded-pill w-100 text-center captcha font-weight-bold f16 m-0 poppins-bold-italic"
                        (click)="randomCaptcha()">{{captchaValue}}</span>
                    </div>
                  </div>
                </div>

                <button class="btn btn-warning w-100" [disabled]="formGroup.invalid && showLoader" type="submit"
                  style="color: #fff;"><i *ngIf="showLoader" class="fa fa-refresh spinner-icon"></i> Login</button>
              </div>
            </form>
            <div class="col-12">
              <div class="row align-items-center justify-content-center">
                <div class="col-10 col-md-11 col-lg-8 p-1">
                  <button class="btn btn-primary w-100" (click)="openModalGantiPass()"
                      style="color: #fff;"> Reset Password</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>

<ng-template #content>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Ganti Password</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModalGantiPass()"><i class="fa fa-close"></i></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formChangePassword" class="form theme-form">
      <div class="row p-t-10">
        <div class="col-12">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">NRK</label>
            <div class="col-sm-8">
              <input id="nrk" name="nrk" type="text" class="form-control" formControlName="nrk">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Sandi Lama</label>
            <div class="col-sm-8">
              <input id="sandiLama" name="sandiLama" type="password" class="form-control" formControlName="sandiLama">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Sandi Baru</label>
            <div class="col-sm-8">
              <input id="sandiBaru" name="sandiBaru" type="password" class="form-control" formControlName="sandiBaru">
              <div class="mt-3">
                <div *ngIf="formChangePassword.get('sandiBaru')?.invalid && formChangePassword.get('sandiBaru')?.errors?.minlength">
                  <small class="text-danger">Password harus memiliki minimal 8 karakter.</small>
                </div>
                <div *ngIf="formChangePassword.get('sandiBaru')?.invalid && formChangePassword.get('sandiBaru')?.errors?.pattern">
                  <small class="text-danger">
                    Password harus mengandung minimal 1 huruf besar, 1 huruf kecil, 1 angka, dan 1 simbol.
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Konfirmasi Sandi</label>
            <div class="col-sm-8">
              <input id="konfirmasiSandiBaru" name="konfirmasiSandiBaru" type="password" class="form-control"
                formControlName="konfirmasiSandiBaru">
                <div class="mt-3">
                  <div *ngIf="formChangePassword.get('konfirmasiSandiBaru')?.invalid && formChangePassword.get('konfirmasiSandiBaru')?.errors?.minlength">
                    <small class="text-danger">Password harus memiliki minimal 8 karakter.</small>
                  </div>
                  <div *ngIf="formChangePassword.get('konfirmasiSandiBaru')?.invalid && formChangePassword.get('konfirmasiSandiBaru')?.errors?.pattern">
                    <small class="text-danger">
                      Password harus mengandung minimal 1 huruf besar, 1 huruf kecil, 1 angka, dan 1 simbol.
                    </small>
                  </div>
                  <div *ngIf="formChangePassword.get('konfirmasiSandiBaru')?.hasError('notMatch')">
                    <small class="text-danger">
                      Password tidak cocok. Harap pastikan kata sandi yang dimasukkan sama.
                    </small>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="modal-footer">
      <!-- <button type="button" class="btn btn-outline-dark" href="/" style="background-color:black; color: white;"><i class="fa fa-arrow-left"></i> Batal</button> -->
      <button [disabled]="formChangePassword.invalid || formChangePassword.hasError('notMatch')"  type="button" class="btn btn-success" (click)="changePasswordLamaAlert()"><i
          class="fa fa-book-arrow-down"></i>Ganti</button>
    </div>
  </div>

</ng-template>

<ng-template #contentGeneratePassword let-closeModal="close" let-dismisModal="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Ganti Password</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismisModal('Cross click'); refresh()">
      <i class="fa fa-close"></i>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formChangePassword" class="form theme-form">
      <div class="row p-t-10">
        <div class="col-12">
          <div class="form-group row align-items-center">
            <label class="col-form-label col-sm-2">Sandi</label> <!-- Label column -->
            <div class="col-sm-10 d-flex"> <!-- Adjusted to use d-flex for alignment -->
              <input id="sandi" name="sandi" [type]="sandiFieldType" class="form-control mr-2" readonly
                style="width: 150px; font-size: large; font-weight: 500; font-style: normal; text-align: center;"
                formControlName="sandi">
              <button type="button" class="btn btn-secondary custom-border mr-2" (click)="togglePasswordVisibility()">
                <i [class]="sandiFieldType === 'password' ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </button>
              <button type="button" class="btn btn-secondary custom-border mr-2" (click)="randomPassword()">
                Generate
              </button>
              <button type="button" class="btn btn-secondary custom-border" (click)="copyToClipboard()">
                <i class="fa fa-copy"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="alert alert-info mt-3">
        <i class="fa fa-info-circle"></i> SILAHKAN KLIK TOMBOL GENERATE UNTUK MENGHASILKAN
        PASSWORD BARU DAN COPY PASSWORD TERSEBUT, SEBELUM DISIMPAN ATAU GANTI PASSWORD!
      </div>
    </form>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" href="/" style="background-color:black; color: white;"
        (click)="dismisModal('Cross click');refresh()">
        <i class="fa fa-arrow-left"></i> Batal
      </button>
      <button type="button" class="btn btn-success" (click)="changePasswordLamaAlert();closeModal('Save click')">
        <i class="fa fa-book-arrow-down"></i> Ganti Password
      </button>
    </div>
  </div>
</ng-template>